var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CampaignInfoMain"},[_c('div',{staticClass:"typed-on-paper"},[_c('CampaignInfoBaseComp',_vm._b({},'CampaignInfoBaseComp',_vm.campaign,false))],1),_vm._v(" "),_c('router-view',{attrs:{"name":"subcontent"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59e66607","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/CampaignInfoMain.vue
// module id = null
// module chunks = 